'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * When the scrollHeight is large than the offsetHeight (which is the height of the container),
 * the browser will show scroll bars. This utility fuction specifies whether the scroll bars are
 * shown on the DOM element pointed to by `ref`.
 * @param {React.MutableRefObject<HTMLDivElement>} ref Th react reference object pointing to a DOM
 * element.
 * @param {number} tolerance The margin of difference between scrollHeight and the DOM Elements's
 * height allowed before this function will specify that scroll bars are being show.
 * @return {boolean} True if scroll bars are determined to be shown, false otherwise.
 */
var hasScroll = function (ref, tolerance) {
    if (tolerance === void 0) { tolerance = 10; }
    if (ref) {
        var node = ref.current || { offsetHeight: tolerance * -1, scrollHeight: 0 };
        return node.offsetHeight + tolerance < node.scrollHeight;
    }
    return true;
};

exports.hasScroll = hasScroll;
